import React, { ComponentProps } from 'react';
import { IconButton } from 'react-native-paper';
import PointIcon from '../CustomIcon';
import { getActions, getItemListClick, isCheckColor } from '../shared';

type Props = ComponentProps<typeof IconButton> | any;

const ActionButton: React.FC<Props> = (props) => {
  const { attributes, onPress, width, height, style: propsStyle } = props;

  const nameIcon = attributes.nameIcon;
  const backgroundColor =
    propsStyle?.backgroundColor || attributes.backgroundColor;
  const color = propsStyle?.color || attributes.color;
  const fontSize = propsStyle?.fontSize || attributes.fontSize;
  const opacity =
    propsStyle?.opacity !== undefined ? propsStyle.opacity : attributes.opacity;
  const borderRadius =
    propsStyle?.borderRadius !== undefined ? propsStyle.borderRadius : 28;
  const finalWidth = propsStyle?.width || width || 56;
  const finalHeight = propsStyle?.height || height || 56;
  const zIndex = attributes.zIndex;

  const handlePress = () => {
    onPress(getActions(props, 'action'), {
      itemListClick: getItemListClick(props.record),
    });
  };

  const childProps: Props = {
    icon:
      nameIcon === 'point'
        ? () => <PointIcon width={24} height={24} fill={color} />
        : nameIcon,
    style: {
      opacity,
      borderRadius,
      backgroundColor: isCheckColor(backgroundColor)
        ? backgroundColor
        : '#4259AC',
      margin: 0,
      width: finalWidth,
      height: finalHeight,
      zIndex,
    },
    color: isCheckColor(color) ? color : '#fff',
    size: fontSize,
  };

  return <IconButton onPress={handlePress} {...childProps} />;
};

export default ActionButton;
